import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";

const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";

export default function DoerProgressModal({ email, open, onClose }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [selectedDept, setSelectedDept] = useState(null);
  const [tableDept, setTableDept] = useState(null);
const [graphDept, setGraphDept] = useState(null);
  const [tableRange, setTableRange] = useState(5);   // 5, 10, or "ALL"
const [graphRange, setGraphRange] = useState(12);  // default 12

  useEffect(() => {
    if (!open || !email) return;
    fetchProgress();
  }, [open, email]);

  async function fetchProgress() {
    try {
      setLoading(true);
      setErr("");

      const res = await fetch(
        `${API_BASE}/em/progress?email=${encodeURIComponent(email)}`
      );

      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json?.error);

      setData(json.data || []);
    } catch (e) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  }

  // ================= GROUP BY DEPARTMENT =================
  const deptGroups = {};
  data.forEach((r) => {
    if (!deptGroups[r.department]) deptGroups[r.department] = [];
    deptGroups[r.department].push(r);
  });

  const deptList = Object.keys(deptGroups);

useEffect(() => {
  if (deptList.length && !graphDept) {
    setGraphDept(deptList[0]);
  }
}, [deptList]);

  if (!open) return null;

  // ================= TABLE GROUP =================
  const grouped = {};
  data.forEach((r) => {
    const key = `${r.weekStart}_${r.weekEnd}`;
    if (!grouped[key]) {
      grouped[key] = {
        meetingDate: r.meetingDate,
        weekStart: r.weekStart,
        weekEnd: r.weekEnd,
        departments: [],
      };
    }
    grouped[key].departments.push(r);
  });

  const groupedList = Object.values(grouped).sort(
    (a, b) => new Date(b.meetingDate) - new Date(a.meetingDate)
  );

  // ================= GRAPH DATA =================
 const deptData = deptGroups[graphDept] || [];

  // 👉 FIX: define allWeeks properly
  const allWeeks = [
    ...new Set(data.map((r) => `${r.weekStart}_${r.weekEnd}`)),
  ];

  // 👉 sort weeks
  const sortedWeeks = allWeeks
    .map((wk) => {
      const [ws] = wk.split("_");
      return { wk, ws: new Date(ws) };
    })
    .sort((a, b) => a.ws - b.ws)
    .map((x) => x.wk);

const limitedWeeks =
  graphRange === "ALL"
    ? sortedWeeks
    : sortedWeeks.slice(-graphRange);

const graphData = limitedWeeks.map((wk, i) => {
    const [ws, we] = wk.split("_");

const row = deptData.find(
  (r) =>
    String(r.weekStart).slice(0, 10) === ws &&
    String(r.weekEnd).slice(0, 10) === we
);
    return {
week: `${new Date(ws).toLocaleDateString("en-GB")}\n${new Date(
  we
).toLocaleDateString("en-GB")}`,

      // totalScore: row ? Number(row.totalScore || 0) : 0,
      totalScore: row ? Number(row.finalScore ?? row.totalScore ?? 0) : null,

      commitmentScore:
  i > 0
    ? (() => {
        const prev = deptData.find(
          (r) =>
            String(r.weekStart).slice(0, 10) ===
            limitedWeeks[i - 1].split("_")[0]
        );

        if (!prev || prev.commitmentScore == null) return null;

        // return Number(prev.commitmentScore);
        return prev?.commitmentScore != null
  ? Number(prev.commitmentScore)
  : null;
      })()
    : null,
    };
  });

  return (
    <div className="modalBackdrop" onMouseDown={onClose}>
      <div
        className="modalCard"
        // style={{ width: "min(1200px, 96vw)" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="modalHeader">
          <div className="modalTitle">📊 Previous Performance</div>
          <button className="btnClose" onClick={onClose}>✕</button>
        </div>

        <div className="modalBody">
          {loading && <div>Loading...</div>}
          {err && <div className="alertErr">⚠ {err}</div>}

          {!loading && !err && (
            <>

<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    flexWrap: "wrap", // responsive
    gap: "10px"
  }}
>
  <div style={{ fontWeight: 600 }}>
    📋 Weekly Review Summary
  </div>

<div style={{ display: "flex", alignItems: "center", gap: 12 }}>
  
  <span style={{ fontWeight: 500 }}>🏢 Department:</span>

<select
 value={tableDept ?? "ALL"}
onChange={(e) =>
  setTableDept(e.target.value === "ALL" ? null : e.target.value)
}
>
  <option value="ALL">All Departments</option>

  {deptList.map((d) => (
    <option key={d} value={d}>{d}</option>
  ))}
</select>

  <span style={{ fontWeight: 500 }}>📅 Table Range:</span>

  <select
    value={tableRange}
    onChange={(e) =>
      setTableRange(e.target.value === "ALL" ? "ALL" : Number(e.target.value))
    }
  >
    <option value={5}>Last 5 Weeks</option>
    <option value={10}>Last 10 Weeks</option>
    <option value="ALL">All Weeks</option>
  </select>
</div>


</div>

<div
  className="tableScroll"
  style={{
    maxHeight: "320px",   // 👈 control table height
    overflowY: "auto",
    border: "1px solid #e5e7eb",
    borderRadius: "8px"
  }}
>
              <table className="dstTable">
                <thead>
                  <tr>
                    <th>Meeting Date</th>
                    <th>Week</th>
                    <th>Department</th>
                    <th>Total Score</th>
                    <th>Commitment</th>
                    <th>Remark</th>
                  </tr>
                </thead>

<tbody>
  {groupedList.length === 0 ? (
    <tr>
      <td colSpan={6}>No data</td>
    </tr>
  ) : (
    (tableRange === "ALL"
      ? groupedList
      : groupedList.slice(0, tableRange)
    ).map((g, i) => {

      // ✅ STEP 1: filter departments
      const filteredDepts = g.departments.filter(
      d => !tableDept || d.department === tableDept
      );

      // ✅ STEP 2: skip if no data after filter
      if (filteredDepts.length === 0) return null;

      return filteredDepts.map((d, j) => (
        <tr key={i + "_" + j}>
          
          {/* ✅ FIXED rowSpan */}
          {j === 0 && (
            <>
              <td rowSpan={filteredDepts.length} style={{ fontWeight: 600 }}>
                {g.meetingDate
                  ? new Date(g.meetingDate).toLocaleDateString("en-GB")
                  : "—"}
              </td>

              <td rowSpan={filteredDepts.length}>
                {new Date(g.weekStart).toLocaleDateString("en-GB")} <br />
                to <br />
                {new Date(g.weekEnd).toLocaleDateString("en-GB")}
              </td>
            </>
          )}

          <td>{d.department}</td>

          <td>
            <span
              style={{
                backgroundColor:
                  Number(d.totalScore) <= -20 ? "#ef4444" : "#30cc69",
                color: "#000",
                padding: "3px 8px",
                borderRadius: "6px",
                display: "inline-block",
                minWidth: "50px",
                textAlign: "center",
                fontSize: "13px",
                fontWeight: 600
              }}
            >
              {Number(d.totalScore || 0).toFixed(2)}
            </span>
          </td>

          {/* ✅ Commitment bold */}
          <td style={{ fontWeight: 600 }}>
            {d.commitmentScore ?? "—"}
          </td>

          <td>{d.commitmentRemark || "—"}</td>
        </tr>
      ));
    })
  )}
</tbody>
              </table>
            </div>
            </>

          )}
        </div>

        {/* ================= GRAPH ================= */}
        <div style={{ padding: 16, marginTop: 16 }}>
<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    flexWrap: "wrap",
    gap: "10px"
  }}
>
  <div style={{ fontWeight: 600 }}>
    📈 Performance Trend ({selectedDept})
  </div>

  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
    <span style={{ fontWeight: 500 }}>📊 Graph Filters:</span>

    <select
      value={graphDept || ""}
onChange={(e) => setGraphDept(e.target.value)}
    >
      {deptList.map((d) => (
        <option key={d} value={d}>{d}</option>
      ))}
    </select>

    <select
      value={graphRange}
      onChange={(e) =>
        setGraphRange(e.target.value === "ALL" ? "ALL" : Number(e.target.value))
      }
    >
      <option value={5}>Last 5</option>
      <option value={10}>Last 10</option>
      <option value={15}>Last 15</option>
      <option value="ALL">All</option>
    </select>
  </div>
</div>
          <div style={{ height: 280 }}>
            <ResponsiveContainer width="100%" height="100%">
             <LineChart
  data={graphData}
  margin={{ top: 10, right: 50, left: 10, bottom: 30 }}
>
<CartesianGrid
  stroke="#e5e7eb"          // light gray
  vertical={false}          // cleaner look
/>
<XAxis
  dataKey="week"
  interval={0}
  height={60}
  tick={({ x, y, payload }) => {
    const lines = payload.value.split("\n");
    return (
      <g transform={`translate(${x},${y})`}>
        {lines.map((line, i) => (
          <text
            key={i}
            x={0}
            y={i * 14}
            dy={16}
            textAnchor="middle"
            fontSize={11}
          >
            {line}
          </text>
        ))}
      </g>
    );
  }}
/>
<YAxis
  domain={[-100, 0]}
  tickCount={6}
  tick={{ fontSize: 12 }}
/>
<Tooltip
  formatter={(value, name, props) => {
    if (name === "Commitment") {
      const total = props.payload.totalScore;
      const commitment = value;

      const status =
        total >= commitment ? "Achieved ✅" : "Missed ❌";

      return [`${value} (${status})`, "Commitment"];
    }

    return [value, name];
  }}
/>
               <Legend
  formatter={(value) => {
    if (value === "Commitment") {
      return "Commitment (🟢 Achieved / 🔴 Missed)";
    }
    return value;
  }}
/>

<Line
  type="monotone"
  dataKey="totalScore"
  stroke="#2563eb"
  strokeWidth={3}
  name="Total Score"
  connectNulls={true}
  
  dot={(props) => {
    const { cx, cy, payload } = props;

    if (payload.totalScore == null) return null; // ❌ no dot

    return (
      <circle
        cx={cx}
        cy={cy}
        r={4}
        fill="#2563eb"
      />
    );
  }}
/>
<Line
  type="monotone"
  dataKey="commitmentScore"
  stroke="#f59e0b"
  strokeWidth={4}
  strokeDasharray="6 6"
  connectNulls={true}
  name="Commitment"
  
  dot={(props) => {
    const { cx, cy, payload } = props;

    if (payload.commitmentScore == null) return null;

    const commitment = Number(payload.commitmentScore);
    const total = Number(payload.totalScore);

    let color = "#f59e0b"; // default orange

    if (total >= commitment) {
      color = "#22c55e"; // ✅ Green (achieved)
    } else {
      color = "#ef4444"; // ❌ Red (missed)
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={8}
        fill={color}
        stroke="#fff"
        strokeWidth={2}
      />
    );
  }}

  activeDot={{ r: 7 }}
/>
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}